import { render } from "./Reload.vue?vue&type=template&id=41fcc75a"
const script = {}
script.render = render

export default script